module.exports = __webpack_public_path__ + "img/1-4.152e8bae.svg";